/**
 * Add a new company
 *
 * @param company
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as commodityActions from "../graphql/actions/commodity";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function add(commodity) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(commodity));
        commodityActions.add(
            function (response) {
                dispatch(saved(response.data.createCommodity));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCommodity(response.data.createCommodity));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            commodity
        );
    };
}

export function edit(commodity) {
    let id = commodity.id;
    delete commodity.id;
    delete commodity.__typename;
    delete commodity.commodityGroupName;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(commodity));
        commodityActions.edit(
            function (response) {
                dispatch(saved(response.data.editCommodity));
                dispatch(fetchCommodities(true));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            commodity
        );
    };
}


export function fetchCommodities(force = false) {
    return dispatch => {
        dispatch(loading());
        commodityActions.getCommodities(
            function (response) {
                dispatch(receiveCommodities(response.data.commodities));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    };
}

export function deleteCommodities(commoditiesID) {
    console.log('// commodity -- test //', commoditiesID);
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/commodities/delete/"+commoditiesID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingCommodities());
        fetch(url, {headers: headers})
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            dispatch(notify({message: l10n.messages.removed, status: 'success'}));
            return response;
        })
        .then(() => {
            dispatch(doneDeletingCommodities());
            dispatch(fetchCommodities(true));
        })
        .catch((error) => {
            dispatch(notify({message: error.message, status: 'error'}));
            dispatch(doneDeletingCommodities());
        });
    };
}

export function deletingCommodities() {
    return {
        type: types.DELETING_COMMODITY
    };
}

export function doneDeletingCommodities() {
    return {
        type: types.DONE_DELETING_COMMODITY
    };
}

export function get(id, force = false) {
    return dispatch => {
        dispatch(loading());
        commodityActions.get(
            function (response) {
                dispatch(receiveCommodity(response.data.commodity));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            id,
            force
        );
    };
}




export function loading() {
    return {
        type: types.LOADING_COMMODITY
    };
}

export function saving(commodity) {
    return {
        type: types.SAVING_COMMODITY,
        payload: commodity
    };
}

export function saved(commodity) {
    return {
        type: types.SAVED_COMMODITY,
        payload: commodity
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_COMMODITY,
    };
}

export function receiveCommodities(data) {
    return {
        type: types.RECEIVED_COMMODITIES,
        payload: data
    };
}


export function receiveCommodity(data) {
    return {
        type: types.RECEIVED_COMMODITY,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/commodity.js